import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const HomeIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.72 8.4L12 2.98L19.28 8.4V19H4.72V8.4ZM17.44 17.16V9.32L12 5.44L6.56 9.32V17.16H17.44Z" />
    </SvgIcon>
  );
});
